//TODO: PCとも共有したほうが良い
// PC側の整理が必要
export {
	stockToSymbol
};

const [UNDEF, NG, WARN, WAIT, OK] = [0, 1, 2, 3, 4];

function getStockStatus(stock) {
	/*
	 * stock
	 * 1-9 在庫実数
	 * 0   キャンセル待ち
	 * -1  予約不可
	 * -2  設定なし
	 */
	const num = Number(stock);
	if (num > 8) {
		return OK;
	} else if (num > 0){
		return WARN;
	} else if (num === 0) {
		return WAIT;
	} else if (num === -1) {
		return NG;
	} else {
		return UNDEF;
	}

}


function stockToSymbol(stock) {
	const stat = getStockStatus(stock);
	return {
		[OK]: {
			symbol:"○",
			cls: "stat_ok"
		},
		[WARN]: {
			symbol:"▲",
			cls: "stat_warn"
		},
		[WAIT]: {
			symbol:"■",
			cls: "stat_wait"
		},
		[UNDEF]: {
			symbol:"",
			cls: "stat_undef"
		},
		[NG]: {
			symbol:"×",
			cls: "stat_ng"
		}
	}[stat];
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/stock.js